import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES, BRAND } from "../../data/content";
import { ReserveDialog } from "../ReserveDialog";
import { Sparkle } from "../shared/Decor";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const trustItems = [
  "Agua, luz y gas incluidos",
  "Vigilancia 24/7",
  "Internet incluido",
  "Estancia mínima 2 meses",
];

export const Hero = () => {
  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Comunidad COLLECTIVE CO LIVING" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-espresso via-espresso/80 to-espresso/55" />
      </div>

      <Sparkle className="absolute top-28 right-12 w-9 text-camel/60 hidden sm:block" />
      <Sparkle className="absolute bottom-28 right-28 w-5 text-linen/40 hidden lg:block" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 w-full pt-28 pb-16 sm:pb-20 lg:pb-24">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="section-overline text-xs font-bold uppercase text-camel"
        >
          COLLECTIVE CO LIVING
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 max-w-4xl font-display font-semibold text-5xl sm:text-7xl lg:text-8xl tracking-tight text-linen leading-[0.98]"
        >
          ¡VIVE EN COMUNIDAD!
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-8 max-w-xl text-base sm:text-lg font-light text-linen/80 leading-relaxed"
        >
          ¿Sabías que vivir en comunidad puede ayudarte a ahorrar mientras disfrutas espacios
          equipados, servicios incluidos y una red de personas con intereses similares? Descubre una
          forma más inteligente, flexible y accesible de vivir en CDMX.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <ReserveDialog>
            <button
              data-testid="hero-reserve-btn"
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-cocoa text-linen px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-camel transition-colors duration-300"
            >
              Apartar habitación
              <ArrowRight size={18} strokeWidth={2} className="transition-transform group-hover:translate-x-1" />
            </button>
          </ReserveDialog>
          <button
            data-testid="hero-rooms-btn"
            onClick={() => scrollTo("habitaciones")}
            className="inline-flex items-center justify-center rounded-full border border-linen/40 text-linen px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-linen/10 transition-colors duration-300"
          >
            Ver habitaciones
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="mt-20 border-t border-linen/15 pt-8 grid grid-cols-2 md:grid-cols-4 gap-6"
        >
          {trustItems.map((item) => (
            <div key={item} className="text-linen/70 text-sm font-light tracking-wide">
              {item}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
